function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiquid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#3f60ea",
      enableBackground: "new"
    },
    d: "M100 50c0-27.6-22.4-50-50-50S0 22.4 0 50s22.4 50 50 50 50-22.4 50-50z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4364f0"
    },
    cx: 50,
    cy: 50,
    r: 37.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M50 28.9c-8.5 12.6-14 20.5-14 28.2C36 64.8 42.3 71 50 71s14-6.2 14-13.9c0-7.6-5.5-15.5-14-28.2zm0 9c.8 1.3 1.8 3.5 1.8 5.8 0 6.9-7 8-7 3.8-.1-2.8 3.4-7 5.2-9.6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquid);
export default __webpack_public_path__ + "static/media/liquid.e9cced774e1a89d6cb739e54781b8496.svg";
export { ForwardRef as ReactComponent };